var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReviewed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6591_25220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 7.77517V8.3885C14.6645 9.82612 14.199 11.225 13.3383 12.3764C12.4775 13.5278 11.2676 14.3702 9.88894 14.7778C8.51032 15.1854 7.03687 15.1364 5.68834 14.6382C4.33982 14.14 3.18847 13.2192 2.406 12.0132C1.62354 10.8072 1.25189 9.38054 1.34648 7.94604C1.44107 6.51154 1.99684 5.14605 2.93088 4.05322C3.86493 2.96038 5.12722 2.19875 6.52949 1.88193C7.93176 1.56511 9.39888 1.71006 10.712 2.29517",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.05518L8 9.72851L6 7.72851",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6591_25220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.388428)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReviewed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reviewed.110afe58.svg";
export { ForwardRef as ReactComponent };